export default __webpack_public_path__ + "static/media/preLoader.ce40594d.gif";